import { Component } from '@angular/core';
import { LoaderService } from '../../core/services/loader.service';
import { I18nService } from '../../core/i18n/i18n.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  template: `
     @if (loaderService.loading()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/50 backdrop-blur-sm transition-opacity">
        <div class="flex flex-col items-center gap-4">
          <!-- Spinning ring with icon -->
          <div class="relative w-20 h-20 flex items-center justify-center">
            <svg class="absolute inset-0 w-20 h-20 animate-spin" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="36" stroke="#ffffff" stroke-width="4" />
              <path d="M40 4a36 36 0 0 1 36 36" stroke="#66D8FE" stroke-width="4" stroke-linecap="round" />
            </svg>
            <img src="assets/images/logo-portrait-white-transparent.png" alt="BlueDop Medical" class="w-10 h-10" />
          </div>
          <div class="text-center">
            <p class="text-base font-semibold text-white">{{ t('common.loading') }}</p>
            <p class="text-sm text-white mt-1">{{ t('common.pleaseWait') }}</p>
          </div>
        </div>
      </div>
     }
  `,
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService, private i18n: I18nService) {}

  t(key: string, params?: Record<string, unknown>): string {
    return this.i18n.t(key, params);
  }
}
